import { useAuthStore } from "../stores/auth";
import { useMyAccountStore } from "../stores/myAccount";

export async function loginGuard(to: any, from: any, next: any): Promise<void> {
  const privatePage = !publicPages.includes(to.path);
  const authStore = useAuthStore();
  if (privatePage && authStore.tokenState.refresh === null) {
    // TODO: send route to login as next
    return next({ name: "login", query: { next: encodeURI(to.fullPath) } });
  }

  if (privatePage) {
    await useMyAccountStore().initUserData(false);
  }

  return next();
}

export const publicPages = [
  "/login",
  "/register",
  "/login/openId-callback",
  "/register-organization",
  "/forgot-password",
  "/reset-password",
];
